import {
  forwardRef,
  Fragment,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";

export const RequiredFieldErrorMessage = forwardRef(({}, ref) => {
  const [showToast, setShowToast] = useState(false);

  useImperativeHandle(ref, () => ({
    showAlert,
  }));
  const showAlert = () => {
    setShowToast(true);
  };

  return (
    <Fragment>
      {showToast && (
        <div
          className="toast error-toast error-toast-redDark show animate__animated animate__bounceIn"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
        >
          <div className="toast-body error-toast-body">
            <div className="toast-body-message">
              <div className="lft-toast-icon toast-redDark-icon">
                <div className="toast-icon-inner toast-redDark-inner">
                  <span className="wes-alert"></span>
                </div>
              </div>
              <div className="lft-toast-msg lft-toast-msgRedDark">
                <h6>Missing Shipping Address Fields</h6>
                <p>Please check and update all mandatory shipping fields</p>
              </div>
            </div>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={() => {
                setShowToast(false);
              }}
            ></button>
          </div>
        </div>
      )}
    </Fragment>
  );
});
